import { render, staticRenderFns } from "./case_new.vue?vue&type=template&id=5c67c66a&scoped=true"
import script from "./case_new.vue?vue&type=script&lang=js"
export * from "./case_new.vue?vue&type=script&lang=js"
import style0 from "./case_new.vue?vue&type=style&index=0&id=5c67c66a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c67c66a",
  null
  
)

export default component.exports